import * as theme from "../../../theme";
import PlusIcon from "../../../formnavigation/PlusIcon";
import MinusIcon from "../../../formnavigation/MinusIcon";

const AccordionItem = ({ item, index, handleToggle, openItem }) => {
  const { address } = item.location;
  return (
    <>
      <div
        style={{
          width: "84%",
          height: "6vh",
          border: "1px solid white",
          backgroundColor: theme.COLORS.tertiary_lightblue,
          display: "flex",
          alignItems: "center",
          paddingLeft: "2vw",
          marginLeft: "8%",
          fontFamily: "GibsonRegular",
          color: theme.COLORS.dark_navy_blue,
          letterSpacing: 1,
          fontSize: "1.7vmin",
        }}
      >
        {address.streetNumber} , {address.town} - {address.postalcode}
        <div style={{ paddingLeft: "1vw" }}>
          {openItem === index ? (
            <MinusIcon
              color={theme.COLORS.secondary_orange}
              onClick={() => handleToggle(index)}
            ></MinusIcon>
          ) : (
            <PlusIcon
              color={theme.COLORS.secondary_orange}
              onClick={() => handleToggle(index)}
            ></PlusIcon>
          )}
        </div>
      </div>
      {/* </div> */}
      {openItem === index && <div>{item.component}</div>}
    </>
  );
};

export default AccordionItem;
